import { Link } from "@/lib/nav";

import CustomerFooter from "@/components/customer-footer";
import CustomerScreenShell from "@/components/customer-screen-shell";
import SectionCard from "@buildpy/ui/section-card";
import { Button } from "@buildpy/ui/button";
import { intakeFromPublicPath } from "@buildpy/core/modules/customer/intake-page";
import type { PublicPortfoliosView } from "@buildpy/core/views/g4b/public-portfolios";
import PublicCaseGrid from "@/modules/portfolio/ui/public-case-grid";
import PublicNotice from "@/modules/portfolio/ui/public-notice";

// 시공사 공개 시공사례 목록 — 로그인 없음 · 공개로 둔 사례만 손으로 정한 순서대로 · 공개 링크로 왔으면 via 를 상세·상담 문의로 옮겨 싣는다.
const Page = ({ data }: { data: PublicPortfoliosView }) => {
  if (data.kind === "notice") return <PublicNotice text={data.text} />;
  const { org, cards, show_inquiry, via } = data;

  return (
    <CustomerScreenShell className="p-0 pb-10">
      <header className="border-b border-border bg-card px-4 pb-4 pt-safe-4">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="truncate text-sm text-muted-foreground">{org.name}</p>
            <h1 className="text-xl font-semibold">시공사례</h1>
          </div>
          {show_inquiry && (
            <Button asChild className="shrink-0" size="sm">
              <Link data-testid="public-portfolio-inquiry" href={intakeFromPublicPath(org.slug, via, null)}>
                상담 문의
              </Link>
            </Button>
          )}
        </div>
      </header>

      <div className="mx-auto w-full max-w-5xl px-4 pt-4">
        {cards.length === 0 ? (
          <SectionCard
            as="div"
            className="p-5 text-center text-sm text-muted-foreground"
            padding="none"
            data-testid="public-portfolio-empty">
            아직 공개된 시공사례가 없습니다.
          </SectionCard>
        ) : (
          <PublicCaseGrid cards={cards} slug={org.slug} via={via} />
        )}
      </div>
      <CustomerFooter className="px-4" show={data.footer} />
    </CustomerScreenShell>
  );
};

export default Page;
